import { render, staticRenderFns } from "./AumentoObligacion.vue?vue&type=template&id=04ba5773&"
import script from "./AumentoObligacion.vue?vue&type=script&lang=js&"
export * from "./AumentoObligacion.vue?vue&type=script&lang=js&"
import style0 from "./AumentoObligacion.vue?vue&type=style&index=0&id=04ba5773&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports